<template>
	<div id="alarm-form-content">
		<bread-crumbs
			class="ml-1"
			:title="breadCrumbsTitle"
			:subTitle="
				alarm_local.days.length > 0 ? $t('general.SubtitleRadiusUpdate') : $t('general.SubtitleRadiusCreate')
			"
			:sizeTitle="22"
			:lineHeightTitle="27"
			:sizeSubTitle="13"
			:lineHeightSubTitle="16"
		>
		</bread-crumbs>
		<div class="vx-row mb-2">
			<div class="vx-col w-full flex items-center">
				<feather-icon
					class="g-breadcrumb--title"
					icon="ChevronLeftIcon"
					svgClasses="h-8 w-8"
					@click.prevent="$emit('changeActiveTabEmit', 0)"
				/>
				<vs-breadcrumb
					class="g-breadcrumb--title"
					separator=""
					:items="[{title: $t('general.Return')}]"
					@click.prevent="$emit('changeActiveTabEmit', 0)"
				></vs-breadcrumb>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col md:w-3/7 w-full p-2">
				<vx-card class="custom-height" style="overflow-y: auto">
					<form class="form-content">
						<vs-row vs-w="12">
							<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
								<div class="vx-row mb-4">
									<div class="vx-col w-full">
										<!-- NAME -->
										<label class="g-label" v-text="$t('Name')"></label>
										<vs-input
											v-model="alarm_local.name"
											class="w-full"
											name="item-name"
											v-validate="'required'"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('item-name')"
											v-text="$t('Alarm.ValidFields.Name')"
										></span>
									</div>
								</div>
								<div class="vx-row">
									<div class="vx-col w-full">
										<small class="g-label" v-text="$t('Object.statusOptions.Date')"></small>
									</div>
								</div>
								<div class="vx-row mb-4">
									<div class="vx-col w-full md:w-1/2">
										<small class="vs-table-text" v-text="$t('general.Initial')"></small>
										<datepicker
											:language="$vs.rtl ? langHe : langEn"
											name="initDate"
											v-validate="'validatorInitDate'"
											v-model="alarm_local.init_date"
										></datepicker>
										<span
											class="text-danger text-sm"
											v-show="errors.has('initDate')"
											v-text="$t('Alarm.DateInitError')"
										></span>
									</div>
									<div class="vx-col w-full md:w-1/2">
										<small class="vs-table-text" v-text="$t('general.End')"></small>
										<datepicker
											v-model="alarm_local.end_date"
											v-validate="'validatorEndDate'"
											name="endDate"
											:language="$vs.rtl ? langHe : langEn"
											:disabledDates="disabledDatesTo"
										></datepicker>
										<span
											class="text-danger text-sm"
											v-show="errors.has('endDate')"
											v-text="$t('Alarm.DateInitError')"
										></span>
									</div>
								</div>
								<div class="vx-row">
									<div class="vx-col w-full">
										<small class="g-label" v-text="$t('general.Hour')"></small>
									</div>
								</div>
								<div class="vx-row mb-4">
									<div class="vx-col w-full md:w-1/2">
										<small class="vs-table-text" v-text="$t('general.Initial')"></small>
										<flat-pickr
											v-model="alarm_local.init_hour"
											name="dataHourInit"
											class="w-full"
											v-validate="'validatorInitHour'"
											:config="configdateTimePicker"
											:placeholder="$t('Select')"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('dataHourInit')"
											v-text="$t('Alarm.ValidInitHour')"
										></span>
									</div>
									<div class="vx-col w-full md:w-1/2">
										<small class="vs-table-text" v-text="$t('general.End')"></small>
										<flat-pickr
											v-model="alarm_local.end_hour"
											class="w-full"
											name="dataHourEnd"
											v-validate="'validatorEndHour'"
											:placeholder="$t('Select')"
											:config="configdateTimePicker"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('dataHourEnd')"
											v-text="$t('Alarm.ValidEndHour')"
										></span>
									</div>
								</div>
								<div class="vx-row mb-2">
									<div class="vx-col w-full">
										<!-- DESCRIPTION -->
										<small class="g-label" v-text="$t('Days')"></small>
										<v-select
											class="w-full"
											v-model="alarm_local.days"
											:placeholder="$t('Select')"
											:multiple="true"
											:closeOnSelect="false"
											:options="daysOptions"
											:dir="$vs.rtl ? 'rtl' : 'ltr'"
											:selectable="
												(option) =>
													!alarm_local.days.find(
														(element) => element == $t('Alarm.SelectAll')
													)
											"
											v-on:input="changeRoute($event)"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
									</div>
								</div>
								<div class="vx-row">
									<div class="vx-col md:w-1/1" v-if="alarmType === 'AlarmBattery'">
										<small class="g-label" v-text="$t('Alarm.BatteryLevel')"></small>
										<vs-input-number
											color="primary"
											icon-inc="expand_less"
											icon-dec="expand_more"
											v-model="alarm_local.level_battery"
										/>
									</div>
									<!-- AlarmRadio -->
									<div class="vx-col w-full md:w-1/1 mt-2" v-if="alarmType === 'AlarmRadio'">
										<small class="g-label">{{ $t("Alarm.AssignateTo") }}</small>
										<v-select
											class="w-full"
											v-model="radiusAlarmAssignateTo"
											:clearable="false"
											:closeOnSelect="true"
											:options="radiusAlarmAssignateToOptions"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
									</div>
									<div
										class="vx-col w-full md:w-1/1 mt-2"
										v-if="radiusAlarmAssignateTo.value === 'radius'"
									>
										<small class="g-label">{{ $t("Alarm.DefineRadius") }} (m)</small>
										<vs-input-number
											@focusout="validateRadiusisnotEmpty"
											:min="radiusAlarmAssignateTo.value === 'radius' ? 1 : 0"
											:max="1000"
											icon-inc="expand_less"
											icon-dec="expand_more"
											v-model="alarm_local.radius"
										/>
									</div>
									<div class="vx-col w-full md:w-1/1 mt-2" v-if="alarmType === 'AlarmRadio'">
										<small class="g-label">{{ $t("Alarm.EventToNotify") }}</small>
										<v-select
											class="w-full"
											v-model="typeAlarmRadio"
											:clearable="false"
											:closeOnSelect="true"
											:options="zoneTypes2"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
									</div>
									<div class="vx-col md:w-1/1 mt-2" v-if="alarmType === 'AlarmSchedule'">
										<small class="g-label">{{ $t("Alarm.TotalVisit") }}</small>
										<vs-input-number
											:min="2"
											:max="100"
											icon-inc="expand_less"
											icon-dec="expand_more"
											v-model="alarm_local.total_events"
										/>
									</div>
									<div class="vx-col w-full md:w-1/1 mt-2" v-if="alarmType === 'AlarmSchedule'">
										<small class="g-label">{{ $t("Alarm.AssignateTo") }}</small>
										<v-select
											class="w-full"
											v-model="assignateTo"
											:clearable="false"
											:closeOnSelect="true"
											:options="assignateToOptions"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
									</div>
									<!-- AlarmZone -->
									<div class="vx-col w-full md:w-1/1" v-if="alarmType === 'AlarmZone'">
										<!-- DESCRIPTION -->
										<div>
											<small class="g-label" v-text="$t('Zonification.Layers')"></small>
											<v-select
												class="w-full"
												v-model="selectedLayer"
												:options="layerOptions"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
										</div>
									</div>
									<div class="vx-col w-full md:w-1/1 mt-2" v-if="alarmType === 'AlarmZone'">
										<small class="g-label" v-text="$t('Zonification.Zone')"></small>
										<vx-input-group>
											<v-select
												class="w-full"
												v-model="zones"
												:options="optionsMulti"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												:placeholder="$t('Select')"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
											<template slot="append">
												<div class="append-text btn-addon">
													<vs-button
														color="success"
														:disabled="alarm_local.cartodb_id <= 0"
														@click="showZone"
														>{{ $t("View") }}
													</vs-button>
												</div>
											</template>
										</vx-input-group>
									</div>
									<div class="vx-col w-full md:w-1/1 mt-2" v-if="alarmType === 'AlarmZone'">
										<!-- TYPE -->
										<div>
											<small class="g-label" v-text="$t('Type')"></small>
											<v-select
												class="w-full"
												v-model="typeBatteryAlarm"
												:options="zoneTypes"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												:placeholder="$t('Select')"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
										</div>

										<vs-alert
											color="danger"
											class="mt-4"
											:title="$t('Error')"
											:active.sync="notFoundZone"
											closable
											icon-pack="feather"
											close-icon="icon-x"
										>
											<span>{{ $t("Zonification.ZonesNotFound") }}</span>
										</vs-alert>
									</div>
								</div>
							</vs-col>
						</vs-row>
					</form>
				</vx-card>
			</div>
			<div class="vx-col md:w-2/7 w-full pl-2">
				<vx-card class="custom-height">
					<resource-assigned-list
						v-if="assignateTo.value === 'resources'"
						:resource_ids="resourceIds"
						:search="true"
						:pagination="true"
					></resource-assigned-list>
					<visit-point-assigned-list
						v-if="alarmType === 'AlarmSchedule' && assignateTo.value === 'visitpoints'"
						:maxHeight="'310px'"
						:visit_point_ids="visitPointsIds"
					></visit-point-assigned-list>
				</vx-card>
			</div>
			<div class="vx-card custom-height vx-col md:w-2/7 w-full p-2">
				<div class="vx-row items-center mt-2">
					<div class="vx-col md:w-4/5">
						<label class="g-table--title" v-text="$t('general.Emails')"></label>
					</div>
					<div v-if="emails_local.length > 1" class="vx-col md:w-1/5">
						<vx-tooltip
							class="cursor-pointer"
							:title="$t('Alarm.DeleteEmails')"
							color="primary"
							position="bottom"
							:text="$t('Alarm.DeleteAllEmails')"
						>
							<feather-icon
								class="g-label--normal"
								size="small"
								icon="TrashIcon"
								svgClasses="h-5 w-5 text-danger cursor-pointer"
								@click.stop="deleteAll('EMAILS')"
							/>
						</vx-tooltip>
					</div>
				</div>
				<div class="vx-row mb-2 mt-4 items-center">
					<div class="vx-col w-full">
						<!-- Append Button -->
						<vx-input-group>
							<vs-input
								id="email"
								v-model="email"
								type="email"
								name="email"
								size="small"
								class="g-label"
								v-validate="'email|min:3'"
								:placeholder="$t('ButtonAddTypeConfig') + ' ' + $t('general.Email')"
								@keypress.enter="addEmail"
							/>
							<template slot="append">
								<div class="append-text btn-addon">
									<vs-button
										color="primary"
										type="filled"
										size="small"
										icon-pack="feather"
										icon="icon-plus"
										:disabled="errors.has('email')"
										@click.prevent="addEmail"
									></vs-button>
								</div>
							</template>
						</vx-input-group>
						<span
							class="text-danger text-sm"
							v-show="errors.has('email')"
							v-text="$t('Alarm.ValidFields.Email')"
						></span>
					</div>
				</div>
				<hr style="border: 0.79px solid #a3a3a3" />
				<vue-perfect-scrollbar class="scroll-email-area" :settings="settings">
					<vs-table v-if="emails_local.length > 0" pagination max-items="7" :data="emails_local">
						<template slot="thead">
							<vs-th class="g-table--title"></vs-th>
							<vs-th class="g-table--title">N.</vs-th>
							<vs-th class="g-table--title">{{ $t("Email") }}</vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<vs-td class="g-table--description" :data="data[indextr]">
									<feather-icon
										class="g-label--normal"
										size="small"
										icon="Trash2Icon"
										svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
										:title="$t('Crud.Delete')"
										@click.prevent="delEmail(data[indextr])"
									/>
								</vs-td>
								<vs-td class="g-table--description">
									{{ indextr + 1 }}
								</vs-td>

								<vs-td class="g-table--description" :data="data[indextr]">
									{{ data[indextr] }}
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
					<p v-else class="g-label--normal text-center" v-text="$t('Alarm.NoAssignedEmail')"></p>
				</vue-perfect-scrollbar>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full">
				<div class="mt-4 flex flex-wrap items-center justify-end">
					<vs-button
						class="mr-2 g-btn--resourcePopup"
						type="border"
						color="danger"
						style="padding: 0.7rem 3.8rem"
						@click.prevent="$emit('changeActiveTabEmit', 0)"
						>{{ $t("Cancel") }}
					</vs-button>
					<vs-button
						v-if="duplicate"
						id="btn-submit-alarm"
						class="vs-con-loading__container ml-4 g-btn--resourcePopup"
						type="filled"
						color="success"
						:disabled="!isFormValid"
						@click.prevent="submitData"
						>{{ $t("Duplicate") + " " + $t("Alarm.Alarm") }}
					</vs-button>
					<vs-button
						v-else
						id="btn-submit-alarm"
						class="vs-con-loading__container ml-4 g-btn--resourcePopup"
						type="filled"
						color="success"
						:disabled="!isFormValid"
						@click.prevent="submitData"
						>{{ $t("Save") + " " + $t("Alarm.Alarm") }}
					</vs-button>
				</div>
			</div>
		</div>
		<vs-popup
			:fullscreen="false"
			:title="$t('Zonification.AssignedZone')"
			:active.sync="mapMounted"
			class="vs-popup--content-custom"
		>
			<here-map
				v-if="mapMounted"
				name="theMap"
				ref="moduleMap"
				latitude="4.686699"
				longitude="-74.0837187"
				zoom="13"
				width="42vw"
				height="75vh"
				theme="uber"
				calledFrom="alarmForm"
				:cartodbId="alarm_local.cartodb_id"
			></here-map>
		</vs-popup>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import {Validator} from "vee-validate";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moduleGroup from "@/store/group/moduleGroup.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleZonification from "@/store/zonification/moduleZonification.js";
import Alarm from "@/models/Alarm";
import AlarmSchedule from "@/models/AlarmSchedule";
import AlarmGps from "@/models/AlarmGps";
import AlarmBattery from "@/models/AlarmBattery";
import AlarmZone from "@/models/AlarmZone";
import Commons from "@/helpers/commons.js";
import DateUtils from "@/helpers/DateUtils.js";
import cartoDB from "@/helpers/cartoDB";
import cartodb from "@/constants/cartodb.js";
import {removeGeoJsonLayer, zoomMap} from "../../utils/HereMap";
import HereMap from "../Maps/Maps";
import AlarmRadio from "../../models/AlarmRadio";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import ResourceAssignedList from "@/components/resource/user-list/ResourceAssignedList";
import VisitPointAssignedList from "@/components/visit-point/list/VisitPointAssignedList";

const {cartoTable} = cartodb;

export default {
	props: {
		data: {
			type: Object,
			default: () => {
				new AlarmRadio({});
			},
		},
		type: {
			type: String,
			default: "",
		},
		triggerCleanDates: {
			type: Number,
		},
		duplicate: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		VisitPointAssignedList,
		ResourceAssignedList,
		HereMap,
		VuePerfectScrollbar,
		flatPickr,
		vSelect,
		Datepicker,
		Treeselect,
	},
	data() {
		return {
			selectAssignedResourcesZones: this.data.radius === 0,
			alarm_local: JSON.parse(JSON.stringify(this.data)),
			alarmType: this.type,
			email: "",
			activeItem: 0,
			disabledFrom: false,
			langHe: es,
			langEn: en,
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			days: [],
			daysOptions: ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"],
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			update: false,
			emails: [],
			selectedLayer: null,
			zones: null,
			optionsMulti: [],
			//typeBatteryAlarm: null,
			zoneTypes: [
				{value: 1, label: "Entrada"},
				{value: 2, label: "Salida"},
				{value: 3, label: "Entrada y Salida"},
			],
			assignateTo: {value: "resources", label: this.$t("Resources")},
			assignateToOptions: [
				{value: "resources", label: this.$t("Resources")},
				{value: "visitpoints", label: this.$t("VisitPoints")},
			],
			radiusAlarmAssignateTo: {value: "zones", label: this.$t("Alarm.AssignedZones")},
			radiusAlarmAssignateToOptions: [
				{value: "zones", label: this.$t("Alarm.AssignedZones")},
				{value: "radius", label: this.$t("Alarm.Radio")},
			],
			typeAlarmRadio: {value: 1, label: this.$t("Alarm.Start")},
			mapMounted: false,
			client: null,
			notFoundZone: false,
			resourceIds: [],
			visitPointsIds: [],
		};
	},
	watch: {
		alarm_local(val) {
			if (val.radius === 0 && this.selectAssignedResourcesZones === false) {
				this.selectAssignedResourcesZones = true;
			}
		},
		selectAssignedResourcesZones(val) {
			if (val === true) {
				this.alarm_local.radius = 0;
			} else {
				this.alarm_local.radius = 1;
			}
		},
		selectedLayer(val) {
			if (!val) {
				removeGeoJsonLayer();
				this.zones = [];
				zoomMap(8);
				return;
			}
			this.getAllPolygons(val.value);
		},
		zones(val) {
			if (val) {
				this.alarm_local.cartodb_id = val.value;
			} else {
				this.zones = [];
				removeGeoJsonLayer();
				zoomMap(8);
			}
		},
		typeBatteryAlarm(val) {
			if (val) {
				this.alarm_local.type_alarm = val.value;
			}
		},
		typeAlarmRadio(val) {
			if (val) {
				this.alarm_local.type_alarm = val.value;
			}
		},
		triggerCleanDates(val) {
			this.cleanDates();
		},
	},
	created() {
		Validator.extend("validatorEndHour", this.validatorEndHour);
		Validator.extend("validatorInitHour", this.validatorInitHour);
		Validator.extend("validatorInitDate", this.validatorInitDate);
		Validator.extend("validatorEndDate", this.validatorEndDate);
		new Validator(
			{trueField: "validatorEndHour"},
			{trueField: "validatorInitHour"},
			{trueField: "validatorInitDate"},
			{trueField: "validatorEndDate"}
		);

		// register Module Group
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}
		// register Module Common
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (!moduleZonification.isRegistered) {
			this.$store.registerModule("moduleZonification", moduleZonification);
			moduleZonification.isRegistered = true;
		}
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		this.fetchLayerList();
		if (this.data.key === "") {
			this.$validator.reset();
			this.initValues();
		} else {
			this.update = true;
			this.initValues();
		}
	},
	mounted() {
		// Create new client
		this.client = cartoDB.client();
		// If prop data exist
		if (this.alarm_local.days.length) {
			if (this.alarm_local.days.length == this.daysOptions.length) {
				this.daysOptions.unshift(this.$t("Alarm.SelectAll"));
				this.alarm_local.days = [];
				this.alarm_local.days.push(this.$t("Alarm.SelectAll"));
			} else {
				this.daysOptions.unshift(this.$t("Alarm.SelectAll"));
			}
		} else {
			this.daysOptions.unshift(this.$t("Alarm.SelectAll"));
		}
	},
	beforeDestroy() {
		this.$store.dispatch("moduleResource/cleanResourceActivity");
	},
	computed: {
		breadCrumbsTitle() {
			let titleBreadCrumbs = "";
			switch (this.alarmType) {
				case "AlarmSchedule":
					if (this.alarm_local.days.length > 0) {
						titleBreadCrumbs = this.$t("Crud.Update") + " " + this.$t("Alarm.ScheduleAlarms");
					} else {
						titleBreadCrumbs = this.$t("general.New2") + " " + this.$t("Alarm.ScheduleAlarms");
					}
					break;
				case "AlarmGps":
					if (this.alarm_local.days.length > 0) {
						titleBreadCrumbs = this.$t("Crud.Update") + " " + this.$t("Alarm.GpsAlarms");
					} else {
						titleBreadCrumbs = this.$t("general.New2") + " " + this.$t("Alarm.GpsAlarms");
					}
					break;
				case "AlarmBattery":
					if (this.alarm_local.days.length > 0) {
						titleBreadCrumbs = this.$t("Crud.Update") + " " + this.$t("Alarm.BatteryAlarms");
					} else {
						titleBreadCrumbs = this.$t("general.New2") + " " + this.$t("Alarm.BatteryAlarms");
					}
					break;
				case "AlarmZone":
					if (this.alarm_local.days.length > 0) {
						titleBreadCrumbs = this.$t("Crud.Update") + " " + this.$t("Alarm.ZoneAlarms");
					} else {
						titleBreadCrumbs = this.$t("general.New2") + " " + this.$t("Alarm.ZoneAlarms");
					}
					break;
				case "AlarmRadio":
					if (this.alarm_local.days.length > 0) {
						titleBreadCrumbs = this.$t("Crud.Update") + " " + this.$t("Alarm.RadioAlarm");
					} else {
						titleBreadCrumbs = this.$t("general.New2") + " " + this.$t("Alarm.RadioAlarm");
					}
					break;
				default:
					titleBreadCrumbs = "";
			}
			return titleBreadCrumbs;
		},
		zoneTypes2() {
			return [
				{value: 1, label: this.$t("Alarm.Start")},
				{value: 2, label: this.$t("Alarm.End")},
				{value: 3, label: this.$t("Alarm.Startandend")},
			];
		},
		isFormValid() {
			return (
				!this.errors.any() &&
				(this.assignedResources.length > 0 || this.assignedVisitPoints.length > 0) &&
				this.alarm_local.days.length > 0 &&
				this.emails.length > 0 &&
				this.alarm_local.init_hour !== "" &&
				this.alarm_local.end_hour !== ""
			);
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		disabledDatesTo() {
			let actualDate = new Date(this.alarm_local.init_date);
			let newDate = new Date(actualDate.getFullYear(), actualDate.getMonth(), actualDate.getDate() + 1);
			return {to: newDate};
		},
		disabledDatesFrom() {
			return {from: new Date(this.alarm_local.init_date)};
		},
		assignedResources() {
			return this.$store.state.moduleResource.resourcesActivity;
		},
		emails_local() {
			return this.emails;
		},
		layerOptions() {
			return Commons.generateSelectOptios(this.$store.state.moduleZonification.layers, "name", "id");
		},
		typeBatteryAlarm: {
			get() {
				const typeBatteryAlarm = this.alarm_local.type_alarm || 1;
				return {
					value: typeBatteryAlarm,
					label: this.zoneTypes.find((t) => t.value === typeBatteryAlarm).label,
				};
			},
			set(val) {
				this.alarm_local.type_alarm = val.value;
			},
		},
		assignedVisitPoints() {
			return this.$store.state.moduleVisitPoint.assignedVisitPoints;
		},
	},
	methods: {
		validateRadiusisnotEmpty() {
			if (this.alarm_local.radius === "") this.selectAssignedResourcesZones = true;
		},
		changeRoute: function (a) {
			// If SelectAll is selected this delete other opcions selected and when sendData delete selectAll and send values
			if (this.alarm_local.days.find((element) => element == this.$t("Alarm.SelectAll"))) {
				if (this.alarm_local.days.find((element) => element !== this.$t("Alarm.SelectAll"))) {
					this.alarm_local.days = this.alarm_local.days.filter(
						(element) => element == this.$t("Alarm.SelectAll")
					);
				}
			}
		},
		deleteAll(value) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Alarm.DeleteAllText") + ` "${value}"`,
				accept: value === "EMAILS" ? this.deleteAllEmails : "",
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAllEmails() {
			this.emails = [];
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		openLoadingBtn() {
			Commons.openLoadingButton.call(this, "btn-submit-alarm");
		},
		closeLoadingBtn() {
			Commons.closeLoadingButton.call(this, "btn-submit-alarm");
		},
		initValues() {
			const alarmType = this.alarmType;
			switch (alarmType) {
				case "AlarmSchedule":
					if (!this.update) this.alarm_local = new AlarmSchedule({});
					else if (
						Object.hasOwnProperty.call(this.alarm_local, "visit_point_id") &&
						this.alarm_local.visit_point_id.length > 0
					) {
						this.alarm_local = new AlarmSchedule(this.alarm_local);
						this.assignateTo.value = "visitpoints";
						this.assignateTo.label = this.$t("VisitPoints");
						this.visitPointsIds = this.alarm_local.visit_point_id;
					} else {
						this.alarm_local = new AlarmSchedule(this.alarm_local);
					}
					break;
				case "AlarmGps":
					if (!this.update) this.alarm_local = new AlarmGps({});
					else this.alarm_local = new AlarmGps(this.alarm_local);
					break;
				case "AlarmBattery":
					if (!this.update) this.alarm_local = new AlarmBattery({});
					else this.alarm_local = new AlarmBattery(this.alarm_local);
					break;
				case "AlarmZone":
					if (this.update) {
						this.alarm_local = new AlarmZone(this.alarm_local);
						this.getLayerByZone(this.alarm_local.cartodb_id);
					} else {
						this.alarm_local = new AlarmZone({});
					}
					break;
				case "AlarmRadio":
					if (this.update) {
						this.alarm_local = new AlarmRadio(this.alarm_local);
						if (this.alarm_local.radius > 0) {
							this.radiusAlarmAssignateTo = {
								value: "radius",
								label: this.$t("Alarm.Radio"),
							};
						}
						const {label, value} = this.zoneTypes2.find((t) => t.value === this.alarm_local.type_alarm);
						this.typeAlarmRadio = {label, value};
					} else {
						this.alarm_local = new AlarmRadio({});
					}
					break;
				default:
					this.alarm_local = new Alarm({});
					break;
			}
			if (this.update) {
				this.getAssignedResources();
				this.emails = [...this.alarm_local.emails];
				if (this.alarmType === "AlarmRadio") {
					this.typeAlarmRadio = {
						label: this.zoneTypes2.find((t) => t.value === this.alarm_local.type_alarm).label,
						value: this.alarm_local.type_alarm,
					};

					if (this.alarm_local.radius === 0) {
						this.selectAssignedResourcesZones = true;
					}
				}
			}
			this.emails = [...this.alarm_local.emails];
		},
		submitData() {
			this.alarm_local.updateResourcesId(this.assignedResources);
			this.alarm_local.init_date = DateUtils.toDefaultDateTime(this.alarm_local.init_date, "YYYY-MM-DD");
			this.alarm_local.end_date = DateUtils.toDefaultDateTime(this.alarm_local.end_date, "YYYY-MM-DD");
			if (this.alarmType === "AlarmSchedule") {
				this.alarm_local["visit_point_id"] = this.assignedVisitPoints.map((avp) => avp.id);
			}
			if (this.alarmType === "AlarmRadio") {
				if (this.radiusAlarmAssignateTo.value === "zones") {
					this.alarm_local.radius = 0;
				}
			}
			this.alarm_local.emails = this.emails;
			if (this.alarm_local.days.find((element) => element == this.$t("Alarm.SelectAll"))) {
				let totalDays = new Array(
					...this.daysOptions.filter((element) => element !== this.$t("Alarm.SelectAll"))
				);
				let newAlarmObject = {};
				newAlarmObject = {...this.alarm_local};
				newAlarmObject.days = totalDays;
				this.$emit("handleSubmitEmit", newAlarmObject, this.update, this.duplicate);
			} else {
				this.$emit("handleSubmitEmit", this.alarm_local, this.update);
			}
		},
		cleanDates() {
			this.alarm_local.init_date = this.addDaysToDate(this.alarm_local.init_date, 1);
			this.alarm_local.end_date = this.addDaysToDate(this.alarm_local.end_date, 1);
		},
		/**
		 * @param{String} stringTime 01:00:45
		 */
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		removeError(errorName) {
			const index = this.errors.items.findIndex((e) => e.field === errorName);
			this.errors.items.splice(index, 1);
		},
		validatorInitDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const ih = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const eh =
				typeof this.alarm_local.end_date === "string"
					? new Date(this.alarm_local.end_date).getTime()
					: this.alarm_local.end_date.getTime();
			return ih <= eh;
		},
		validatorEndDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const eh = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const ih =
				typeof this.alarm_local.init_date === "string"
					? new Date(this.alarm_local.init_date).getTime()
					: this.alarm_local.init_date.getTime();
			return eh >= ih;
		},
		validatorEndHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			if (this.alarm_local.init_hour === "" || value === "") {
				return true;
			}
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.alarm_local.init_hour);
		},
		validatorInitHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			if (this.alarm_local.end_hour === "" || value === "") {
				return true;
			}
			return this.stringTimeToDate(value) < this.stringTimeToDate(this.alarm_local.end_hour);
		},
		getAssignedResources() {
			this.openLoading();
			const data = {
				ids: this.alarm_local.resources_id,
				fields: ["id", "name", "lastname", "username", "identification", "email"],
			};
			this.$store
				.dispatch("moduleResource/getResourcesByFilter", data, {
					component: "activitycreate",
				})
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Alarm.ErrorGetResourceFilter.Title"),
						text: this.$t("Alarm.ErrorGetResourceFilter.Text"),
					});
					throw new Error(err);
				});
		},
		addEmail() {
			if (!this.emails_local.includes(this.email) && this.email.trim().length > 2) {
				this.emails.unshift(this.email.trim().toLowerCase());
				this.email = "";
				setTimeout(() => {
					this.errors.clear();
				}, 50);
			}
			if (this.emails_local.includes(this.email)) {
				this.$vs.notify({
					title: this.$t("Alarm.ErrorGetResourceFilter.Title"),
					text: this.$t("general.EmailAlreadyAdded"),
					position: "top-right",
					time: 7000,
				});
			}
		},
		delEmail(email) {
			// Delete item from email local
			const index = this.emails.findIndex((e) => e === email);
			this.emails.splice(index, 1);
		},
		fetchLayerList() {
			this.$store
				.dispatch("moduleZonification/fetchLayerListItems")
				.then((res) => {
					if (Array.isArray(res.data)) {
						this.layers = res.data;
					}
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		getAllPolygons(layerId) {
			cartoDB
				.executeQuery(`SELECT * FROM ${cartoTable} WHERE layer LIKE '${layerId}'`)
				.then((res) => {
					this.generateOptionsMulti(res.data.rows);
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		getLayerByZone(cartodb_id) {
			cartoDB
				.executeQuery(`SELECT * FROM ${cartoTable} WHERE cartodb_id = ${cartodb_id}`)
				.then((res) => {
					const zoneData = res.data.rows[0];
					const layerFound = this.layerOptions.find((l) => l.value === parseInt(zoneData.layer));
					if (layerFound) {
						this.selectedLayer = layerFound || null;
						this.zones = {
							value: zoneData.cartodb_id,
							label: zoneData.name,
						};
					} else {
						this.notFoundZone = true;
					}
				})
				.catch((err) => {
					this.notFoundZone = true;
					throw new Error(err);
				});
		},
		showZone() {
			this.mapMounted = true;
		},
		generateOptionsMulti(rows) {
			this.optionsMulti = Commons.generateSelectOptios(rows, "name", "cartodb_id");
		},
		addDaysToDate(stringDate, dayNums) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
	},
};
</script>

<style lang="scss" scoped>
#alarm-form-content {
	height: 100%;
}

.scroll-area {
	margin: 10px;
	height: 400px;
}

.scroll-email-area {
	margin: 10px;
	height: 400px;
}

.custom-height {
	width: 100%;
	height: 550px;
}
</style>
